import { Delete } from '@material-ui/icons';
import React from 'react';
import styled, { css } from 'styled-components';
import DeleteBin from 'utils/images/bin.svg';

const DeleteIcon = styled.img`
  width: 14px;
  margin-right: 7px;
`;

const Container = styled.div`
  text-align: left !important;
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  clear: both;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 28px;
  padding: 5px 0px 5px 5px;

  :hover {
    border-color: #000;
  }

  > svg {
    vertical-align: middle;
    float: left;
    font-size: 19px;
    margin-right: 5px;
  }

  > span {
    vertical-align: middle;
    display: flex;
    float: left;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: -0.2px;
  }

  > a {
    display: flex;
    text-decoration: none !important;
    color: black !important;
  }

  > .add-menu-item {
    vertical-align: middle;
  }

  ${props =>
    props.variant === 'secondary'
      ? css`
          border: none;

          > span {
            vertical-align: middle;
            display: flex;
            float: left;
            font-family: 'Basier Circle';
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            letter-spacing: -0.20000000298023224px;
            text-align: left;
            white-space: nowrap;
          }
        `
      : undefined}
`;

function DeleteButton(props) {
  return (
    <Container
      variant={props.variant}
      style={props.style}
      className={props.className}
      onClick={props.disabled ? null : props.onClick}
    >
      {props.variant === 'secondary' ? (
        <DeleteIcon src={DeleteBin} />
      ) : (
        <Delete />
      )}{' '}
      <span>{props.children}</span>
    </Container>
  );
}

export default DeleteButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/DeleteButton/index.jsx